export default {
  startTimes: null,
};
